import React from 'react';
import styled from 'styled-components';
import { SinglePagePdf, PdfList } from '@components';
import { useClient } from '@context/presentation';
import { generateStorageBlobUrl } from '@utils/generateAssetLinks';
import { BLOB_TYPES } from '@constants';
import { ScrollBarStyle } from '@slides/styles';

const PdfDisplay = styled.div`
    position: ${props => props.testingPageStyle ? 'relative' : 'absolute'};    
`;

const PdfSidebarStyle = styled.div`
    position: absolute;
    width: 250px;
    right: 0;
    height: 700px;
    overflow-y: scroll;
    ${ScrollBarStyle}
`;

export const PresenterDocumentView = ({ slideRef, slideState, dispatch, children, testingPageStyle = false }) => {
    const { firmShortName } = useClient();
    const { pdfPageNumber } = slideState;
    const pdfUrl = generateStorageBlobUrl(BLOB_TYPES.pdf, firmShortName);

    return (
        <>
            <PdfDisplay testingPageStyle={testingPageStyle}>
                <SinglePagePdf
                    data-testid='rep-pdf'
                    slideState={slideState}
                    dispatch={dispatch}
                    slideRef={slideRef} />
                    {children}
            </PdfDisplay>
            <PdfSidebarStyle>
                <PdfList
                    pageNumber={pdfPageNumber}
                    dispatch={dispatch}
                    pdfUrl={pdfUrl}
                    pageHeight={250}/>
            </PdfSidebarStyle>
        </>
    );
};

export default PresenterDocumentView;
